module.exports = {
	"title": {
		"artist": "Ascolta {artistName} su Qobuz",
		"album": "Ascolta l'album {albumName} di {artistName} su Qobuz  ",
		"track": "Ascolta {trackName} di {artistName} su Qobuz  ",
		"playlist": "Ascolta la playlist {playlistName} di {ownerName} su Qobuz  ",
		"story": "Leggi questo Articolo su Qobuz"
	},
	"buttons": {
		"listen": "Ascoltare su Qobuz",
		"buy": "Acquista",
		"share": "Condividi",
		"download": "Prova gratis",
		"readmore": "Continuare a leggere",
		"showless": "Mostra meno",
		"showmore": "Vedi di più",
		"morealbums": "Altri album su Qobuz",
		"moreplaylisttrack": "Scopri il seguito su Qobuz",
		"readfocus": "Leggere questa Panoramica su Qobuz",
		"seeSubscribes": "Vedi le offerte d'abbonamento ",
		"cookies": "Impostazioni dei cookie"
	},
	"infos": {
		"trackCount": "{count} tracce",
		"label": "Etichetta : {label}",
		"composer": "Compositore : {composer}",
		"producers": "Produzione",
		"mixers": "Mixaggio/Mastering",
		"diskCount": "{count} album",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privata ",
			"public": "Pubblica"
		},
		"hires": "Alta risoluzione",
		"available": "Disponibile in"
	},
	"share": {
		"twitter": {
			"track": "Ascolta {title} di {artist} su Qobuz ",
			"album": "Ascolta {title} di {artist} su Qobuz",
			"artist": "Ascolta {artist} su Qobuz ",
			"playlist": "Ascolta {playlist} di  {owner} su Qobuz  ",
			"story": "Leggi questo articolo su Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} di {artist} è disponibile su Qobuz!",
				"body": "Ascolta {title} di {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione.\nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} di {artist} è disponibile su Qobuz!",
				"body": "Ascolta {title} di {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione. \nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} è su Qobuz!",
				"body": "Ascolta {artist} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione. \nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} di {owner} è disponibile su Qobuz!",
				"body": "Ascolta {playlist} di {owner} con Qobuz in alta risoluzione: {url}\n\nQobuz è il primo servizio di ascolto e download di musica in alta risoluzione.\nMaggiori informazioni e abbonamenti su Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "Per saperne di più {url}\n\nQobuz è il primo servizio di streaming e download di musica in alta qualità.\nPiù informazioni e la possibilità di registrarsi su Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Clicca per copiare",
			"copy": "Copiare",
			"copied": "Copiato",
			"link": "Copia il seguente link per condividerlo"
		}
	},
	"tracklist": {
		"title": {
			"track": "Traccia",
			"album": "Titoli dell'album",
			"artist": "I migliori titoli",
			"artist_albums": "Album",
			"playlist": "Titoli della playlist"
		},
		"header": {
			"number": "#",
			"name": "Titolo",
			"album": "Album",
			"artist": "Artista",
			"time": "Durata",
			"label": "Etichetta"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Nessuna traccia disponibile"
	},
	"story": {
		"404": {
			"title": "L'articolo richiesto non esiste nella tua area geografica.",
			"description": "Torna alla homepage del Qobuz Magazine"
		},
		"from": "Di {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Iscriviti a Qobuz per leggere l'articolo completo...",
		"signUp": "Prova gratuitamente"
	},
	"playlist": {
		"from": "Di {author}"
	},
	"album": {
		"by": "di",
		"publishedBy": "Pubblicato su"
	},
	"notifications": {
		"nostream": "I titolari dei diritti non hanno reso possibile l'ascolto di questa traccia"
	},
	"aside": {
		"title": "A proposito"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/it.json
// module id = 569
// module chunks = 0